import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { InputField, SelectField } from "./InputAndSelectField";

const Step1BasicInfo = ({ data, onUpdate }: any) => {
  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    onUpdate({ [name]: type === "checkbox" ? checked : value });
  };
  const users = useSelector((state: RootState) => state.users.allUsersNames);
  const attendanceMetadata = useSelector(
    (state: RootState) => state.attendance.attendanceMetadata
  );
  return (
    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md">
      <h2 className="text-xl font-semibold text-gray-900 mb-6 pb-2 border-b border-gray-200">
        Employee Information
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 tracking-wide">
            Username *
          </label>
          <select
            name="userId"
            value={data.userId || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 bg-gray-50 rounded-md shadow-sm 
      focus:outline-none focus:ring-2 focus:ring-blue-500 
      transition duration-200 ease-in-out hover:border-gray-400"
          >
            <option value="">Select</option>
            {users.map((user) => (
              <option key={user._id} value={user._id}>
                {user.username}
              </option>
            ))}
          </select>
        </div>

        <InputField
          label="Employee ID *"
          name="employeeNo"
          value={data.employeeNo}
          placeholder="FE-0001"
          onChange={handleChange}
          required
        />
        <InputField
          label="Name(As Per Aadhar) *"
          name="aadharName"
          value={data.aadharName}
          placeholder="John Doe"
          onChange={handleChange}
          required
        />
        <InputField
          label="Surname *"
          name="surname"
          value={data.surname}
          placeholder="John Doe"
          onChange={handleChange}
          required
        />
        <InputField
          label="Father Name"
          name="fatherName"
          value={data.fatherName}
          placeholder="Father's Full Name"
          onChange={handleChange}
        />
        <InputField
          label="Spouse Name"
          name="spouseName"
          value={data.spouseName}
          placeholder="Spouse's Name"
          onChange={handleChange}
        />
        <SelectField
          label="Marital Status"
          name="maritalStatus"
          value={data.maritalStatus}
          options={attendanceMetadata?.maritalStatus || ["single", "married"]}
          onChange={handleChange}
        />
        {data.maritalStatus?.toLowerCase() === "married" && (
          <InputField
            label="Marriage Date"
            name="marriageDate"
            type="date"
            value={data.marriageDate}
            onChange={handleChange}
          />
        )}
        <InputField
          label="Date of Birth *"
          name="dob"
          type="date"
          value={data.dob}
          onChange={handleChange}
          required
        />
        <SelectField
          label="Gender"
          name="gender"
          value={data.gender}
          options={attendanceMetadata?.gender || []}
          onChange={handleChange}
        />
        <InputField
          label="Mobile Number *"
          name="mobile"
          value={data.mobile}
          placeholder="9876543210"
          onChange={handleChange}
          maxLength={10}
        />
        <InputField
          label="Personal Email *"
          name="email"
          type="email"
          value={data.email}
          placeholder="john@example.com"
          onChange={handleChange}
          required
        />
        <InputField
          label="Aadhaar Card Number *"
          name="aadhaar"
          value={data.aadhaar}
          placeholder="1234 5678 9012"
          onChange={handleChange}
          maxLength={14}
        />
        <InputField
          label="PAN Card Number *"
          name="pan"
          value={data.pan}
          placeholder="ABCDE1234F"
          onChange={handleChange}
          maxLength={10}
          className="uppercase"
        />
        <SelectField
          label="Blood Group"
          name="bloodGroup"
          value={data.bloodGroup}
          options={attendanceMetadata?.bloodGroup || []}
          onChange={handleChange}
        />
        <InputField
          label="Current Address"
          name="currentAddress"
          value={data.currentAddress}
          placeholder="Full Current Address"
          onChange={handleChange}
        />
        <InputField
          label="Permanent Address"
          name="permanentAddress"
          value={data.permanentAddress}
          placeholder="Full Permanent Address"
          onChange={handleChange}
          disabled={data.sameAddress}
        />
        <div className="col-span-2">
          <label className="inline-flex items-center mb-2">
            <input
              type="checkbox"
              checked={data.sameAddress}
              onChange={(e) =>
                onUpdate({
                  sameAddress: e.target.checked,
                  permanentAddress: e.target.checked ? data.currentAddress : "",
                })
              }
              className="mr-2"
            />
            Current address is same as Permanent address
          </label>
        </div>
      </div>
      <div className="mb-6 p-6 bg-gray-50 rounded-xl border border-gray-200">
        <h3 className="text-md font-semibold text-gray-900 mb-4">
          Emergency Contact
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InputField
            label="Contact Name *"
            name="emergencyContactName"
            value={data.emergencyContactName}
            placeholder="Contact Person Name"
            onChange={handleChange}
          />
          <InputField
            label="Contact Number *"
            name="emergencyContactNumber"
            value={data.emergencyContactNumber}
            placeholder="9876543210"
            onChange={handleChange}
            maxLength={10}
          />
          <div className="md:col-span-2">
            <InputField
              label="Relationship"
              name="emergencyContactRelation"
              value={data.emergencyContactRelation}
              placeholder="Relationship with employee"
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1BasicInfo;
